import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useWishlist } from "@/contexts/WishlistContext";
import LookCard from "@/components/LookCard";

export default function Wishlist() {
  const { ids } = useWishlist();
  const [looks, setLooks] = useState([]);
  useEffect(() => { api.get("/looks").then(({ data }) => setLooks(data.filter(l => ids.includes(l.id)))); }, [ids]);
  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24">
      <div className="text-[11px] tracking-editorial uppercase text-[#C3B1C5] mb-3">♡ Saved Looks</div>
      <h1 className="font-serif-display text-[42px] md:text-[56px] tracking-tight">Your Wishlist</h1>
      <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-5 gap-y-14">
        {looks.map((l, i) => <LookCard key={l.id} look={l} index={i} />)}
        {looks.length === 0 && <div className="col-span-full text-center text-[13px] text-[#4A464A]/60 py-24">No saved looks yet — tap the heart on any look you love.</div>}
      </div>
    </div>
  );
}
